import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import DisclaimerNote from "@/components/DisclaimerNote";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center p-6 relative">
      <div className="absolute inset-0 grid-noise pointer-events-none" />
      <div className="w-full max-w-md hard-card hard-card-shadow p-8 relative">
        <Link to="/login" className="overline mb-8 inline-block hover:underline">← BACK TO SIGN IN</Link>
        <h1 className="font-heading font-black text-3xl tracking-tight mb-2">Forgot Password</h1>
        <p className="text-sm text-muted-foreground mb-6">Enter your account email and we'll send you a secure link to reset your password. The link expires in 1 hour.</p>

        {sent ? (
          <div data-testid="forgot-password-sent" className="border-2 border-ink bg-secondary/50 p-4 font-mono text-sm">
            <div className="overline mb-2">§ CHECK YOUR EMAIL</div>
            If an account exists for <b>{email}</b>, a password reset link has been sent. Please check your inbox (and spam).
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" autoComplete="off">
            <div>
              <div className="overline mb-2">Email</div>
              <input
                data-testid="forgot-password-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="off"
                placeholder="you@company.com"
                className="w-full px-4 py-3 border-2 border-ink font-mono text-sm focus:outline-none focus:ring-2 focus:ring-ink"
              />
            </div>
            {err && <div data-testid="forgot-password-error" className="border-2 border-bad text-bad font-mono text-xs p-3">{err}</div>}
            <button
              data-testid="forgot-password-submit"
              type="submit"
              disabled={busy}
              className="hard-btn w-full py-3 font-mono uppercase tracking-widest text-sm disabled:opacity-60"
            >
              {busy ? "Sending…" : "Send Reset Link →"}
            </button>
          </form>
        )}
      <DisclaimerNote />
      </div>
    </div>
  );
}
